import { useQuery } from 'hooks/useCustomQuery';
import getAvailableServiceProfiles from 'API/ServiceProfiles/getAvailableServiceProfiles';
import { SRT } from 'pages/dashboards/v5/constants';

/**
 * The channel ceiling the company's SRT service profile defines.
 *
 * A service may not allocate more channels than its profile allows (2240).
 * Returns null when the profile cannot be read, in which case callers apply no
 * ceiling rather than blocking the save on missing data.
 *
 * @param {object} params
 * @param {string} params.companyID
 */
const useGetSRTProfileMaxChannel = ({ companyID }) => {
    return useQuery({
        queryKey: ['srtProfileMaxChannel', companyID],
        queryFn: async () => {
            const profiles = await getAvailableServiceProfiles(companyID);
            const srtProfile = (profiles || []).find(
                ({ serviceType }) => serviceType === SRT,
            );
            return srtProfile?.maxChannel ?? null;
        },
        enabled: Boolean(companyID),
    });
};

export default useGetSRTProfileMaxChannel;
